// src/ecrans/accueil/BlocADecider.jsx — « À décider » de l'Accueil NEST
// (maquette v819) : ce qui attend l'accord de l'admin, en trois groupes
// classés par ce que ça coûte d'attendre (barème `coutSiRate`,
// src/lib/accueil-urgence.js : Urgent 0-9, Aujourd'hui 10-19, Peut attendre
// 20 et plus). « Urgent » est ouvert ; les autres se déplient par « Voir les
// N lignes » ou « Tout voir (N) ».
//
// Chaque ligne : icône, titre, sous-titre (« repéré par l'opérateur » pour
// une veille), étiquette de délai quand la donnée la porte, un micro, et
// « Traiter ». Dans ce lot, « Traiter » mène à l'écran de la ligne ; le micro
// ouvre l'opérateur, sans sujet (il ne sait pas encore en recevoir un) : son
// libellé dit « Ouvrir l'opérateur », rien de plus. Aucune écriture d'ici.

import { useState } from "react";
import { EtatLecture, mot } from "../nest";
import { IcBulle, MICRO } from "./accueil-style";
import { groupesADecider } from "./accueil-calculs";

export function LigneDecision({ l, onTraiter, onMicro, libelle = "Traiter", testId }) {
  return (
    <div className="nacc-row" data-testid={testId || `dec-${l.cle}`}>
      <IcBulle ic={l.ic} />
      <div className="nacc-tx">
        <b>{l.titre}</b>
        <span>
          {l.operateur ? <i className="nacc-op">repéré par l'opérateur</i> : null}
          {l.sousTitre || l.sous || ""}
        </span>
      </div>
      {l.quand ? <span className="nacc-quand">{l.quand}</span> : null}
      <button
        type="button"
        className="nacc-mic"
        onClick={() => onMicro && onMicro(l)}
        aria-label="Ouvrir l'opérateur"
        title="Ouvrir l'opérateur"
      >
        {MICRO}
      </button>
      <button type="button" className="nacc-go" onClick={() => onTraiter && onTraiter(l)}>
        {libelle}
      </button>
    </div>
  );
}

/** Le chiffre de « À décider » : « … » en lecture, « — » si une lecture a raté. */
export function nombreADecider(attend) {
  if (attend.enLecture) return "…";
  return attend.complet ? attend.lignes.length : "—";
}

export default function BlocADecider({ attend, erreurs = [], onTraiter, onMicro }) {
  const [tout, setTout] = useState(false);
  const n = nombreADecider(attend);
  const groupes = groupesADecider(attend.lignes);
  const lues = attend.lignes.length;
  // Une lecture ratée : on dit ce qui est vrai (la liste peut être
  // incomplète, et combien de lignes ont été lues), jamais « — choses ».
  const sous =
    n === "…"
      ? "On lit…"
      : n === "—"
        ? `Une lecture a échoué : la liste peut être incomplète · ${lues} ${mot(lues, "ligne lue", "lignes lues")}`
        : n === 0
          ? "Rien à décider."
          : `${n} ${mot(n, "chose attend", "choses attendent")} votre accord · classées par ce que ça coûte d'attendre`;
  return (
    <section className="nacc-carte nacc-dec" data-testid="accueil-a-decider">
      <header className="nacc-hd">
        <div style={{ minWidth: 0 }}>
          <h3>À décider</h3>
          <p data-testid="accueil-a-decider-sous">{sous}</p>
        </div>
        {attend.lignes.length ? (
          <button type="button" className="nacc-lien" onClick={() => setTout((v) => !v)} aria-expanded={tout}>
            {tout ? "Réduire" : typeof n === "number" ? `Tout voir (${n})` : "Tout voir"}
          </button>
        ) : null}
      </header>
      {erreurs.map((e) => (
        <EtatLecture key={e.quoi} lecture={e.lecture && e.lecture.etat === "echec" ? e.lecture : null} quoi={e.quoi} />
      ))}
      {groupes.map((g) => {
        const ouvert = tout || g.cle === "urgent";
        return (
          <div key={g.cle} className={`nacc-g-${g.cle}`} data-testid={`accueil-groupe-${g.cle}`}>
            <div className="nacc-gt">
              <span>{g.titre}</span>
              <em>{g.lignes.length}</em>
            </div>
            {ouvert ? (
              <div className="nacc-list">
                {g.lignes.map((l) => (
                  <LigneDecision key={l.cle} l={l} onTraiter={onTraiter} onMicro={onMicro} />
                ))}
              </div>
            ) : (
              <button type="button" className="nacc-plus" onClick={() => setTout(true)}>
                {g.lignes.length <= 1 ? "Voir la ligne" : `Voir les ${g.lignes.length} lignes`}
              </button>
            )}
          </div>
        );
      })}
    </section>
  );
}
